import SideModal from '@components/Modal/Side';
import { jsx as _jsx } from "react/jsx-runtime";
function Modal() { return /*#__PURE__*/ _jsx(SideModal, {}); }
export default Modal;
